import React from 'react'

function Post() {
  return (
    <div>PostDetail</div>
  )
}

export default Post